import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "count"];

  connect() {
    // listen for changes to any checkbox within the dropdown menu
    this.menuTargets.forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        this.updateButtonLabel();
      });
    });

    // update the button label on page load
    this.updateButtonLabel();
  }

  updateButtonLabel() {
    const selectedCheckboxes = this.menuTarget.querySelectorAll(
      'input[type="checkbox"]:checked'
    );

    if (selectedCheckboxes.length === 0) {
      this.countTarget.classList.remove("num-filters");
      this.countTarget.classList.add("hidden");
    } else {
      this.countTarget.classList.remove("hidden");
      this.countTarget.classList.add("num-filters");
      this.countTarget.innerText = selectedCheckboxes.length;
    }
  }
}
